module.exports = __webpack_public_path__ + "static/media/send.e4060b0c.svg";